<template>
	<div class="d-flex flex-column align-end justify-end px-2" v-if="isClosedContract">
		<v-chip
			color="#f2f2f2"
			text-color="black"
			label
			class="mr-2 px-2">
			<p class="mb-0">Valor UF Fijado: <b>${{localUfValue?.uf_value | toThousandFilter(2)}} - {{localUfValue?.date | toDate}}</b></p>
		</v-chip>
		<!-- <div class="d-flex align-center" style="gap: 5px;">
			<p class="mb-0 caption flex-1">Valor UF Fijado al <b>{{localUfValue.date | toDateFormat}}</b>:</p>
			<p class="mb-0 font-weight-bold caption">${{localUfValue.uf_value | toThousandFilter(2)}}</p>
		</div>
		<div class="d-flex align-center" style="gap: 5px;">
			<p class="mb-0 caption flex-1">Tipo Impuesto Fijado:</p>
			<p class="mb-0 font-weight-bold caption">{{localTax.name}} - {{localTax.value}}%</p>
		</div> -->
	</div>
	<div class="d-flex align-center justify-end" v-else>
		<v-select
			:value="localUfValue"
			:items="ufValues"
			:menu-props="{ top: true, offsetY: true }"
			label="Seleccione Valor UF"
			item-text="uf_value"
			item-value="id"
			class="custom-height-search custom-height-calendar custom-select-uf align-center mb-0 mr-1 w-100"
			outlined
			dense
			required
			return-object
			style="width: 180px;max-width: 180px;"
			@change="changeUfSelection"
		>
			<template v-slot:item="data">
				<v-list-item-content>
					<v-list-item-title>
						<div class="d-flex align-center justify-space-between" style="width: 180px">
							<p class="mb-0">{{data.item.date | toDateFormat}}</p>
							<p class="mb-0 font-weight-bold">${{data.item.uf_value | toThousandFilter(2)}}</p>
						</div>
					</v-list-item-title>
				</v-list-item-content>
			</template>
			<template v-slot:selection="data">
				<div class="d-flex align-center justify-space-between" style="width: 180px;margin-bottom: 10px;">
					<p class="mb-0 caption">{{data.item.date | toDateFormat}}</p>
					<span>-</span>
					<p class="mb-0 font-weight-bold caption">${{data.item.uf_value | toThousandFilter(2)}}</p>
				</div>
			</template>
		</v-select>
		<v-select
			:value="localTax"
			:items="taxOptions"
			:loading="$store.state.general.loadingTaxesOptions"
			:menu-props="{ top: true, offsetY: true }"
			item-text="name"
			item-value="id"
			label="Tipo Impuesto"
			class="custom-height-search custom-height-calendar flex-grow-0"
			style="width: 220px"
			outlined
			dense
			required
			return-object
			@change="changeTaxSelection"
		>
			<template v-slot:item="data">
				<v-list-item-content>
					<v-list-item-title>
						<div class="d-flex align-center justify-space-between">
							<div class="d-flex align-center justify-space-between flex-1">
								<p class="mb-0 flex-1">{{data.item.tax.name}}</p>
								<p class="mb-0 font-weight-bold">{{data.item.tax.value}}%</p>
							</div>
						</div>
					</v-list-item-title>
				</v-list-item-content>
			</template>
			<template v-slot:selection="data">
				<div class="d-flex align-center justify-space-between flex-1" style="min-width: 100%;">
					<p class="mb-0 caption flex-1">{{data.item.tax.name}}</p>
					<p class="mb-0 font-weight-bold caption">{{data.item.tax.value}}%</p>
				</div>
			</template>
		</v-select>
	</div>
</template>

<script>
import {updateContract} from '@/helpers/api/contracts'
import { debounce } from 'lodash';
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import { contractStatuses } from '@/components/Helpers/Constants/contract.js'

export default {
	name: 'SubcontractUfTaxSelector',
	props: {
		subcontract: {
			type: Object,
			required: true
		},
	},
	computed: {
		ufValues(){
			return this.$store.state.general.posteriorDaysUf
		},
		taxOptions(){
			return this.$store.state.general.taxesOptions
		},
		subcontractStatus(){
			return this.subcontract?.subcontract?.contract?.last_status?.status
		},
		isClosedContract(){
			return this.subcontractStatus >= contractStatuses.ACEPTADO
		}
	},
	data() {
		return {
			localTax: this.subcontract.subcontract?.contract?.info?.tax || null,
			localUfValue: this.subcontract.subcontract?.contract?.info?.uf_value || null,

		}
	},
	created() {
		this.debouncedUpdateInfo = debounce(this.updateInfo, 500);
	},
	mounted(){
		console.log('Mounted SubcontractUfTaxSelector with subcontract:', this.subcontract);
	},
	methods: {
		changeTaxSelection(value) {
			this.localTax = value;
			this.debouncedUpdateInfo();
		},
		changeUfSelection(value) {
			this.localUfValue = value;
			this.debouncedUpdateInfo();
		},
		async updateInfo(){
			await updateContract({
				contract_id: this.subcontract.subcontract.contract.id,
				tax_id: this.localTax.id,
				uf_id: this.localUfValue.id
			})
			this.$emit('info-updated', { tax: this.localTax, uf_value: this.localUfValue })
			eventBus.$emit('reloadInformation')
		}
	}
}
</script>

<style>

</style>